import React, { useEffect, useState } from "react";
import user from "../../assets/images/user.png";
import listIcon from "../../assets/images/list-icon1.png";
// import Heart from "../../assets/images/icon _heart.png";
import { FREELANCER } from "../../Router/paths";
import { Link } from "react-router-dom";
import { FaRegHeart, FaSearch } from "react-icons/fa";
import { axiosInstance } from "../../config/https";
import { useLoader } from "../../context/LoaderContext";
import { toast } from "react-toastify";
import { skills } from "../../utils";

export default function FreelancerDashboard() {
  const { startLoader, stopLoader } = useLoader();
  const [allJobs, setAllJobs] = useState([]);
  const [activeTab, setActiveTab] = useState("most recent");
  const [term, setTerm] = useState("");
  const [filterSkills, setFilterSkills] = useState([]);
  const userData = JSON.parse(localStorage.getItem("user"));
  // console.log("filterSkills", filterSkills);

  useEffect(() => {
    const getJobs = () => {
      startLoader();
      axiosInstance
        .get(
          activeTab === "saved"
            ? "/api/saved-jobs/"
            : `/api/jobposts/${
                activeTab === "most recent" ? "?order_by=most_recent" : ""
              }`
        )
        .then((resp) => {
          stopLoader();
          const Data = resp.data;
          if (resp.status === 200 || resp.status === 201) {
            setAllJobs(Data.data);
          } else {
            toast.warning(Data.msg);
          }
        })
        .catch(() => {
          stopLoader();
        });
    };
    getJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const savedJob = (jobId) => {
    startLoader();
    axiosInstance
      .post(`/api/save-job/${jobId}/`)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        toast.success(Data.message);
      })
      .catch((err) => {
        stopLoader();
      });
  };

  const SearchTerm = (e) => {
    e.preventDefault();
    startLoader();
    axiosInstance
      .get(`/api/job-posts/search/?term=${term}`)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        setAllJobs(Data);
      })
      .catch((err) => {
        stopLoader();
      });
  };

  const filterByCategory = (e) => {
    if (e.target.checked) {
      setFilterSkills((prev) => [...prev, e.target.value]);
    } else {
      setFilterSkills(
        filterSkills.filter((a) => {
          return a !== e.target.value;
        })
      );
    }
  };

  const filteredData =
    activeTab === "saved"
      ? filterSkills.length === 0
        ? allJobs
        : allJobs.filter((item) => {
            return filterSkills.some((skill) =>
              item.job_post.skills.some((itemSkill) => itemSkill.name === skill)
            );
          })
      : filterSkills.length === 0
      ? allJobs
      : allJobs.filter((item) => {
          return filterSkills.some((skill) =>
            item.skills.some((itemSkill) => itemSkill.name === skill)
          );
        });

  return (
    <section className="freelancer-dashboard-sec pc-p-3">
      <div className="container-fluid px-5">
        <div className="row">
          <div className="col-lg-3 col-md-3 col-12">
            <div className="freelancer-user-side-box">
              <div className="p-3">
                <img
                  src={
                    userData?.profile_picture
                      ? userData?.profile_picture?.profile_picture
                      : user
                  }
                  style={{
                    width: "45px",
                    height: "45px",
                    objectFit: "cover",
                    objectPosition: "top",
                    borderRadius: "50%",
                  }}
                  alt="User"
                />
                <h4>{userData?.user?.name}</h4>
                {/* <h5>Graphic Designer</h5> */}
              </div>
              <div className="side-profile">
                <p className="mb-0">Complete your profile</p>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: "100%" }}
                    aria-valuenow={25}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    100%
                  </div>
                </div>
              </div>
              <ul className="side-profile-tabs">
                <li>
                  <Link
                    onClick={() => setActiveTab("most recent")}
                    className={activeTab === "most recent" ? "active" : ""}
                  >
                    Most Recent
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => setActiveTab("saved")}
                    className={activeTab === "saved" ? "active" : ""}
                  >
                    Saved
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => setActiveTab("all")}
                    className={activeTab === "all" ? "active" : ""}
                  >
                    All
                  </Link>
                </li>
              </ul>
            </div>
            <div className="side-category-dropdown">
              <h4>Filter By Skills</h4>
              <ul>
                {skills.map((e, i) => (
                  <li key={i}>
                    <input
                      type="checkbox"
                      value={e.value}
                      id={e.value}
                      onChange={filterByCategory}
                    />
                    &nbsp;
                    <label htmlFor={e.value}>{e.label}</label>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-lg-9 col-md-9 col-12">
            <div className="row align-items-center mb-5">
              <div className="col-md-6">
                <h2 className="text-capitalize font-weight-bold mb-0">
                  {activeTab}
                </h2>
              </div>
              <div className="col-md-6">
                <form action="#" className="search-form" onSubmit={SearchTerm}>
                  <div className="form-group mb-0">
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search Jobs..."
                      value={term}
                      onChange={(e) => setTerm(e.target.value)}
                    />
                    <button type="submit">
                      <FaSearch />
                    </button>
                  </div>
                </form>
              </div>
              {/* <div className="col-lg-3">
              <button className="primary-btn black-bg">
                {" "}
                <FaSlidersH /> Filters{" "}
              </button>
            </div> */}
            </div>

            {!allJobs.length && <h2>No Data Found</h2>}
            {/* allJobs.skills.include(...filterSkills) */}
            {activeTab === "saved"
              ? filteredData.map((e, i) => (
                  <div className="freelancer-post-box" key={i}>
                    <div className="d-flex justify-content-between align-items-center">
                      <h4>
                        <Link to={FREELANCER.submitProposal} state={e}>
                          {e?.job_post?.job_title}
                        </Link>
                      </h4>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => savedJob(e.id)}
                      >
                        <FaRegHeart size={32} />
                      </span>
                      {/* <img src={Heart} alt="Heart Icon" /> */}
                    </div>
                    <h5>
                      Fixed-price - {e?.job_post?.experience_needed} - Est.
                      Budget: ${e?.job_post?.project_budget} - Posted{" "}
                      {e?.job_post?.created_time}
                    </h5>
                    <p>{e?.job_post?.description}</p>
                    <div className="tags">
                      <ul>
                        {e?.job_post?.skills?.map((e) => (
                          <li key={e?.id}>{e?.name}</li>
                        ))}
                      </ul>
                    </div>
                    <p className="mt-3">
                      <span>Proposals:</span> {e?.job_post?.numofproposals}
                    </p>
                    <ul className="flncr-payment-list">
                      <li>
                        {e?.verified && (
                          <>
                            <span>
                              <img src={listIcon} alt="List Icon" />
                            </span>{" "}
                            <span>Payment Verified</span>
                          </>
                        )}
                      </li>
                      {/* <li>
                        <span>
                          <ul>
                            <li className="list-inline-item">
                              <FaStar />
                            </li>
                            <li className="list-inline-item">
                              <FaStar />
                            </li>
                            <li className="list-inline-item">
                              <FaStar />
                            </li>
                            <li className="list-inline-item">
                              <FaStar />
                            </li>
                            <li className="list-inline-item">
                              <FaStar />
                            </li>
                          </ul>{" "}
                        </span>{" "}
                        $ 100+ spent
                      </li> */}
                    </ul>
                  </div>
                ))
              : filteredData.map((e, i) => (
                  <div className="freelancer-post-box" key={i}>
                    <div className="d-flex justify-content-between align-items-center">
                      <h4>
                        <Link to={FREELANCER.submitProposal} state={e}>
                          {e?.job_title}
                        </Link>
                      </h4>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => savedJob(e.id)}
                      >
                        <FaRegHeart size={32} />
                      </span>
                      {/* <img src={Heart} alt="Heart Icon" /> */}
                    </div>
                    <h5>
                      Fixed-price - {e?.experience_needed} - Est. Budget: $
                      {e?.project_budget} - Posted {e?.created_time}
                    </h5>
                    <p style={{ textAlign: "justify" }}>{e?.description}</p>
                    <div className="tags">
                      <ul>
                        {e?.skills?.map((e) => (
                          <li key={e?.id}>{e?.name}</li>
                        ))}
                      </ul>
                    </div>
                    <p className="mt-3">
                      <span>Proposals:</span> {e?.numofproposals}
                    </p>
                    <ul className="flncr-payment-list">
                      <li>
                        {e?.verified && (
                          <>
                            <span>
                              <img src={listIcon} alt="List Icon" />
                            </span>{" "}
                            <span> Payment Verified</span>
                          </>
                        )}
                      </li>
                      {/* <li>
                        <span>
                          <ul>
                            <li className="list-inline-item">
                              <FaStar />
                            </li>
                            <li className="list-inline-item">
                              <FaStar />
                            </li>
                            <li className="list-inline-item">
                              <FaStar />
                            </li>
                            <li className="list-inline-item">
                              <FaStar />
                            </li>
                            <li className="list-inline-item">
                              <FaStar />
                            </li>
                          </ul>{" "}
                        </span>{" "}
                        $ 100+ spent
                      </li> */}
                    </ul>
                  </div>
                ))}
          </div>
        </div>
      </div>
    </section>
  );
}
